<div class="container">

  <ng-template #defaultNotificationTemplate let-payload>
    <div class="item">
      <int-default-notification
        [title]="payload?.title"
        [description]="payload?.description"
        [addedDescription]="payload?.addedDescription"
        [mode]="payload?.type"
        [closeFn]="payload?.closeFn"
        [template]="payload?.template"
        [templatePayload]="payload?.templatePayload"
      >
      </int-default-notification>
    </div>
  </ng-template>

  <ng-container *ngFor="let template of (templates$ | async) || []">
    <ng-container *ngTemplateOutlet="template.template; context: {$implicit: template.payload}" ></ng-container>
  </ng-container>

</div>

